import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/workflows")({
  component: WorkflowsLayout,
});

/**
 * The global Workflows surface — now a LAYOUT route. It keeps the page
 * chrome (the cream/dark full-height container) and renders the active
 * child via `<Outlet />`: `/workflows` (the library) and
 * `/workflows/$specId` (the detail). Backend-wired children land in
 * later beads; this route owns only the shared container.
 */
function WorkflowsLayout() {
  return (
    <div className="min-h-[calc(100vh-3.5rem)] bg-home-cream px-4 py-6 font-body text-home-ink md:px-8 md:py-8 lg:min-h-screen dark:bg-surface-dark dark:text-white">
      <Outlet />
    </div>
  );
}
